import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.focus()

    setTimeout(() => {
      this.dismiss();
    }, 500000);
  }

  dismiss() {
    this.element.remove();
  }
}
